import React from "react";
import ResourceListPage from "commons/components/ResourceListPage";

const columns = [
  {
    name: "shift",
    type: "text",
    sortable: true,
    searchable: true,
    searchKey: "shifts.name",
  },
  {
    name: "employee",
    type: "text",
    sortable: true,
    searchable: true,
    searchKey: "employees.name",
  },
  {
    name: "active_from",
    type: "date",
    sortable: true,
    searchable: true,
  },
  {
    name: "active_to",
    type: "date",
    sortable: true,
    searchable: true,
  },
];

export default function List({ title, query }) {
  return (
    <ResourceListPage
      url="schedules"
      columns={columns}
      title={title}
      baseQuery={query}
    />
  );
}
